import React from 'react';
import { Container, Row, Col, Card, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHeart, faCalendarCheck, faSearch } from '@fortawesome/free-solid-svg-icons';

interface ActivityDashboardProps {
  user: any;
}

const ActivityDashboard: React.FC<ActivityDashboardProps> = ({ user }) => {
  // Mock data for demonstration
  const stats = {
    propertiesViewed: 47,
    propertiesSaved: 5,
    toursScheduled: 2,
    daysActive: 14,
    searchProgress: 75
  };

  const recentSearches = [
    "Homes near BASIS school",
    "Pool homes under 600k",
    "Scottsdale new construction"
  ];

  const insights = [
    "You prefer single-story homes with large kitchens",
    "Properties you view average 2,400 sqft",
    "You spend most time looking at photos of kitchens",
    "Based on your activity, you're a serious buyer!"
  ];

  return (
    <Container fluid className="activity-dashboard p-4">
      <h2 className="mb-4">📊 Your Search Activity</h2>
      
      {/* Progress Bar */}
      <Card className="mb-4">
        <Card.Body>
          <h5>Search Progress</h5>
          <ProgressBar 
            now={stats.searchProgress} 
            label={`${stats.searchProgress}% Complete`}
            variant="success"
          />
          <p className="text-muted mt-2">
            Keep going! You're getting closer to finding your perfect home.
          </p>
        </Card.Body>
      </Card>

      <Row>
        {/* Stats Column */}
        <Col md={6}>
          <Card className="mb-4">
            <Card.Body>
              <h5>Your Stats</h5>
              <div className="stat-item d-flex justify-content-between py-2">
                <span><FontAwesomeIcon icon={faEye} /> Properties Viewed</span>
                <strong>{stats.propertiesViewed}</strong>
              </div>
              <div className="stat-item d-flex justify-content-between py-2">
                <span><FontAwesomeIcon icon={faHeart} /> Saved</span>
                <strong>{stats.propertiesSaved}</strong>
              </div>
              <div className="stat-item d-flex justify-content-between py-2">
                <span><FontAwesomeIcon icon={faCalendarCheck} /> Tours</span>
                <strong>{stats.toursScheduled}</strong>
              </div>
              <div className="stat-item d-flex justify-content-between py-2">
                <span>Days Active</span>
                <strong>{stats.daysActive}</strong>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Insights Column */}
        <Col md={6}>
          <Card className="mb-4">
            <Card.Body>
              <h5>Theta's Insights</h5>
              <ul className="list-unstyled">
                {insights.map((insight, index) => (
                  <li key={index} className="mb-2">
                    <span className="text-primary">💡</span> {insight}
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Recent Searches */}
      <Card>
        <Card.Body>
          <h5>Recent Searches</h5>
          <div className="recent-searches">
            {recentSearches.map((search, index) => (
              <div key={index} className="search-item py-2">
                <FontAwesomeIcon icon={faSearch} className="me-2 text-muted" />
                {search}
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ActivityDashboard;